/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityCategoryPage = lazyLoad(
  () => import('./index'),
  module => module.EntityCategoryPage
);
